import { request } from "services";

const getSignInUrl = () => {
  const params = new URLSearchParams({
    policy_name: "B2C_1_Authentication",
    platform: "web-patient",
    environment: String(process.env.REACT_APP_ENV),
  });
  const path = `/auth/authorize?${params}`;

  return request({ path }).then((res) => {
    return res.data.d.url as string;
  });
};

export { getSignInUrl };
